"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AVAUtil = {
  get: function get(url, headers) {
    if (typeof fetch !== 'function') {
      return;
    } // eslint-disable-next-line consistent-return


    return new Promise(function (resolve, reject) {
      fetch(url, {
        method: 'GET',
        headers: headers
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        }

        return reject(response);
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  post: function post(url, headers, payload) {
    if (typeof fetch !== 'function') {
      return;
    } // eslint-disable-next-line consistent-return


    return new Promise(function (resolve, reject) {
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: headers
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        }

        return reject(response);
      }).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
var _default = AVAUtil;
exports.default = _default;